var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsupportedLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 344.167,
    height: 125.672,
    viewBox: "0 0 344.167 125.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23587",
    "data-name": "Group 23587",
    transform: "translate(-543.416 -218.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23584",
    "data-name": "Group 23584",
    transform: "translate(-8.102 -393.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23499",
    "data-name": "Group 23499",
    transform: "translate(633.156 732.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23498",
    "data-name": "Group 23498",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    cx: 96.265,
    cy: 2.895,
    rx: 96.265,
    ry: 2.895,
    fill: "#e3e7fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23540",
    "data-name": "Group 23540",
    transform: "translate(663.935 612.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23500",
    "data-name": "Group 23500",
    transform: "translate(0 82.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22055",
    "data-name": "Path 22055",
    d: "M935.3,1430.151H928.17a5.2,5.2,0,1,1,0-10.4h42.14a2.375,2.375,0,0,0,0-4.75h-23.3a3.71,3.71,0,1,1,0-7.421h24.137a10.643,10.643,0,0,0,10.631-10.63v-5.011H983.1v5.011a11.966,11.966,0,0,1-11.953,11.951H947.006a2.389,2.389,0,1,0,0,4.778h23.3a3.7,3.7,0,0,1,0,7.393H928.17a3.878,3.878,0,1,0,0,7.755H935.3Z",
    transform: "translate(-922.97 -1391.941)",
    fill: "#699dee",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23501",
    "data-name": "Group 23501",
    transform: "translate(12.331 118.329)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 105.903,
    height: 4.073,
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23502",
    "data-name": "Group 23502",
    transform: "translate(15.258 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22056",
    "data-name": "Path 22056",
    d: "M1071.7,1702.363h-4.486l-.573,2.546h5.728Z",
    transform: "translate(-1066.644 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23503",
    "data-name": "Group 23503",
    transform: "translate(21.321 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22057",
    "data-name": "Path 22057",
    d: "M1128.786,1702.363H1124.3l-.573,2.546h5.728Z",
    transform: "translate(-1123.727 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23504",
    "data-name": "Group 23504",
    transform: "translate(27.382 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22058",
    "data-name": "Path 22058",
    d: "M1185.861,1702.363h-4.486l-.574,2.546h5.729Z",
    transform: "translate(-1180.802 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23505",
    "data-name": "Group 23505",
    transform: "translate(33.446 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22059",
    "data-name": "Path 22059",
    d: "M1242.952,1702.363h-4.488l-.571,2.546h5.727Z",
    transform: "translate(-1237.894 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23506",
    "data-name": "Group 23506",
    transform: "translate(39.507 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22060",
    "data-name": "Path 22060",
    d: "M1300.027,1702.363h-4.487l-.571,2.546h5.728Z",
    transform: "translate(-1294.969 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23507",
    "data-name": "Group 23507",
    transform: "translate(45.568 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22061",
    "data-name": "Path 22061",
    d: "M1357.1,1702.363h-4.488l-.574,2.546h5.728Z",
    transform: "translate(-1352.035 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23508",
    "data-name": "Group 23508",
    transform: "translate(51.63 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22062",
    "data-name": "Path 22062",
    d: "M1414.179,1702.363h-4.488l-.573,2.546h5.728Z",
    transform: "translate(-1409.119 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23509",
    "data-name": "Group 23509",
    transform: "translate(57.692 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22063",
    "data-name": "Path 22063",
    d: "M1471.262,1702.363h-4.488l-.573,2.546h5.729Z",
    transform: "translate(-1466.202 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23510",
    "data-name": "Group 23510",
    transform: "translate(63.755 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22064",
    "data-name": "Path 22064",
    d: "M1528.345,1702.363h-4.488l-.572,2.546h5.728Z",
    transform: "translate(-1523.285 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23511",
    "data-name": "Group 23511",
    transform: "translate(69.817 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22065",
    "data-name": "Path 22065",
    d: "M1585.427,1702.363h-4.486l-.573,2.546h5.728Z",
    transform: "translate(-1580.368 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23512",
    "data-name": "Group 23512",
    transform: "translate(75.879 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22066",
    "data-name": "Path 22066",
    d: "M1642.5,1702.363h-4.486l-.574,2.546h5.729Z",
    transform: "translate(-1637.443 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23513",
    "data-name": "Group 23513",
    transform: "translate(81.941 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22067",
    "data-name": "Path 22067",
    d: "M1699.587,1702.363H1695.1l-.572,2.546h5.728Z",
    transform: "translate(-1694.528 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23514",
    "data-name": "Group 23514",
    transform: "translate(88.004 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22068",
    "data-name": "Path 22068",
    d: "M1756.669,1702.363h-4.487l-.571,2.546h5.729Z",
    transform: "translate(-1751.61 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23515",
    "data-name": "Group 23515",
    transform: "translate(97.12 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22069",
    "data-name": "Path 22069",
    d: "M1842.511,1702.363h-4.488l-.573,2.546h5.728Z",
    transform: "translate(-1837.45 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23516",
    "data-name": "Group 23516",
    transform: "translate(103.181 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22070",
    "data-name": "Path 22070",
    d: "M1899.585,1702.363H1895.1l-.574,2.546h5.729Z",
    transform: "translate(-1894.525 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23517",
    "data-name": "Group 23517",
    transform: "translate(109.245 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22071",
    "data-name": "Path 22071",
    d: "M1956.676,1702.363h-4.486l-.573,2.546h5.727Z",
    transform: "translate(-1951.617 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23518",
    "data-name": "Group 23518",
    transform: "translate(15.258 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22072",
    "data-name": "Path 22072",
    d: "M1067.7,1702.363v1.737l4.539.3.132.506h-5.728l.573-2.546Z",
    transform: "translate(-1066.644 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23519",
    "data-name": "Group 23519",
    transform: "translate(21.321 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22073",
    "data-name": "Path 22073",
    d: "M1124.784,1702.363v1.737l4.539.3.132.506h-5.728l.573-2.546Z",
    transform: "translate(-1123.727 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23520",
    "data-name": "Group 23520",
    transform: "translate(27.382 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22074",
    "data-name": "Path 22074",
    d: "M1181.859,1702.363v1.737l4.538.3.133.506H1180.8l.574-2.546Z",
    transform: "translate(-1180.802 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23521",
    "data-name": "Group 23521",
    transform: "translate(33.446 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22075",
    "data-name": "Path 22075",
    d: "M1238.949,1702.363v1.737l4.538.3.134.506h-5.727l.571-2.546Z",
    transform: "translate(-1237.894 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23522",
    "data-name": "Group 23522",
    transform: "translate(39.507 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22076",
    "data-name": "Path 22076",
    d: "M1296.025,1702.363v1.737l4.539.3.133.506h-5.728l.571-2.546Z",
    transform: "translate(-1294.969 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23523",
    "data-name": "Group 23523",
    transform: "translate(45.568 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22077",
    "data-name": "Path 22077",
    d: "M1353.094,1702.363v1.737l4.538.3.132.506h-5.728l.574-2.546Z",
    transform: "translate(-1352.035 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23524",
    "data-name": "Group 23524",
    transform: "translate(51.63 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22078",
    "data-name": "Path 22078",
    d: "M1410.175,1702.363v1.737l4.539.3.133.506h-5.728l.573-2.546Z",
    transform: "translate(-1409.119 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23525",
    "data-name": "Group 23525",
    transform: "translate(57.692 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22079",
    "data-name": "Path 22079",
    d: "M1467.258,1702.363v1.737l4.54.3.133.506H1466.2l.573-2.546Z",
    transform: "translate(-1466.202 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23526",
    "data-name": "Group 23526",
    transform: "translate(63.755 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22080",
    "data-name": "Path 22080",
    d: "M1524.342,1702.363v1.737l4.538.3.133.506h-5.728l.572-2.546Z",
    transform: "translate(-1523.285 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23527",
    "data-name": "Group 23527",
    transform: "translate(69.817 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22081",
    "data-name": "Path 22081",
    d: "M1581.425,1702.363v1.737l4.539.3.132.506h-5.728l.573-2.546Z",
    transform: "translate(-1580.368 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23528",
    "data-name": "Group 23528",
    transform: "translate(75.879 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22082",
    "data-name": "Path 22082",
    d: "M1638.5,1702.363v1.737l4.538.3.134.506h-5.729l.574-2.546Z",
    transform: "translate(-1637.443 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23529",
    "data-name": "Group 23529",
    transform: "translate(81.941 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22083",
    "data-name": "Path 22083",
    d: "M1695.584,1702.363v1.737l4.538.3.135.506h-5.728l.572-2.546Z",
    transform: "translate(-1694.528 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23530",
    "data-name": "Group 23530",
    transform: "translate(88.004 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22084",
    "data-name": "Path 22084",
    d: "M1752.667,1702.363v1.737l4.538.3.135.506h-5.729l.571-2.546Z",
    transform: "translate(-1751.61 -1702.363)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23531",
    "data-name": "Group 23531",
    transform: "translate(97.12 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22085",
    "data-name": "Path 22085",
    d: "M1838.507,1702.363v1.737l4.539.3.132.506h-5.728l.573-2.546Z",
    transform: "translate(-1837.45 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23532",
    "data-name": "Group 23532",
    transform: "translate(103.181 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22086",
    "data-name": "Path 22086",
    d: "M1895.583,1702.363v1.737l4.538.3.133.506h-5.729l.574-2.546Z",
    transform: "translate(-1894.525 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23533",
    "data-name": "Group 23533",
    transform: "translate(109.245 115.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22087",
    "data-name": "Path 22087",
    d: "M1952.674,1702.363v1.737l4.538.3.132.506h-5.727l.573-2.546Z",
    transform: "translate(-1951.617 -1702.363)",
    fill: "#1d2340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23534",
    "data-name": "Group 23534",
    transform: "translate(51.85 65.825)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3713",
    "data-name": "Rectangle 3713",
    width: 25.446,
    height: 29.87,
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23535",
    "data-name": "Group 23535",
    transform: "translate(7.045 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3714",
    "data-name": "Rectangle 3714",
    width: 115.055,
    height: 74.812,
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23536",
    "data-name": "Group 23536",
    transform: "translate(12.255 5.394)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3715",
    "data-name": "Rectangle 3715",
    width: 104.638,
    height: 60.431,
    fill: "#eff9fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23537",
    "data-name": "Group 23537",
    transform: "translate(42.724 95.695)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3716",
    "data-name": "Rectangle 3716",
    width: 43.698,
    height: 6.915,
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23538",
    "data-name": "Group 23538",
    transform: "translate(51.85 74.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22088",
    "data-name": "Path 22088",
    d: "M1436.88,1316.58l-21.61,14.521v4.425l21.368,1.937h-25.446V1316.58Z",
    transform: "translate(-1411.193 -1316.58)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23539",
    "data-name": "Group 23539",
    transform: "translate(12.255 5.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22089",
    "data-name": "Path 22089",
    d: "M1038.359,662.933v1.974h102.7L1143,723.364V662.933Z",
    transform: "translate(-1038.359 -662.933)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23541",
    "data-name": "Group 23541",
    transform: "translate(679.317 619.974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3717",
    "data-name": "Rectangle 3717",
    width: 33.429,
    height: 55.566,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23555",
    "data-name": "Group 23555",
    transform: "translate(651.74 619.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23542",
    "data-name": "Group 23542",
    transform: "translate(14.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22090",
    "data-name": "Path 22090",
    d: "M959.268,688.7c0,.137-.013.272-.029.407.681.211.6,1.968-.416,1.968-.954,0-2.6,5.287-5.743,5.287-2.347,0-4.191-2.177-5.406-3.455-.243.27-.585-.465-1.139-.465a1.723,1.723,0,0,1-1.37-1.692,1.959,1.959,0,0,1,.269-1.008,1.758,1.758,0,0,1-.78-1.527,2.02,2.02,0,0,1,.12-.692,1.439,1.439,0,0,1-.255-2.72,1.5,1.5,0,0,1-.053-.393,1.394,1.394,0,0,1,1.692-1.4.985.985,0,0,1,.9-.784h0A2.062,2.062,0,0,1,949,680.068a1.886,1.886,0,0,1,1.574.894,1.781,1.781,0,0,1,1.438-.336v-.008c0-1.509,2.2-1.348,2.338-.287,1.544-1.763,4.322-1.014,3.553.809.832.241,1.471.56,1.471,1.056a2.128,2.128,0,0,1-.431,1.306c2.317.751,1.516,1.893.66,2.553a1.189,1.189,0,0,1,.482,1.065C960.089,687.724,960.178,688.583,959.268,688.7Z",
    transform: "translate(-943.659 -679.328)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23543",
    "data-name": "Group 23543",
    transform: "translate(15.397 14.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22091",
    "data-name": "Path 22091",
    d: "M957.918,815.444a35.045,35.045,0,0,1-.655,5.914l-4.137,2.887,15.573,2.331-3.715-5.13s-1.12-5.476-.533-7.5S957.918,815.444,957.918,815.444Z",
    transform: "translate(-953.126 -813.314)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23544",
    "data-name": "Group 23544",
    transform: "translate(0 22.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22092",
    "data-name": "Path 22092",
    d: "M840.694,890.1v.009a41.1,41.1,0,0,0-5.294-.975,7.366,7.366,0,0,1-3.8,2.886c-2.126-.293-3.917-2.912-3.917-2.973a23.772,23.772,0,0,0-4.514.86c-.12.015-6.214.824-15.02,17.512a29.32,29.32,0,0,0,8.409,8.45c-.455-.937-.9-1.877-1.286-2.717-.757-1.662-1.273-2.937-1.125-3.06.281-.232,3.416-2.955,5.73-4.965-.019.5-.023.96-.012,1.356a102.653,102.653,0,0,1-.055,11.244,29.231,29.231,0,0,0,23.719.818c-.392-3.411-.949-7.377-1.1-10.424q-.116-2.325-.216-4.262c2.127,1.85,6.84,5.944,7.187,6.232.148.123-.367,1.4-1.125,3.06-.572,1.253-1.283,2.725-1.954,4.086a29.29,29.29,0,0,0,9.775-8.476C846.84,890.609,840.694,890.1,840.694,890.1Z",
    transform: "translate(-808.145 -889.049)",
    fill: "#699dee",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23545",
    "data-name": "Group 23545",
    transform: "translate(20.167 16.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22093",
    "data-name": "Path 22093",
    d: "M998.036,838.685s1.231,2.965,3.55,2.9,2.848-2.688,2.848-2.688Z",
    transform: "translate(-998.036 -838.685)",
    fill: "#ed985f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23546",
    "data-name": "Group 23546",
    transform: "translate(18.677 7.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22094",
    "data-name": "Path 22094",
    d: "M991.986,749.709h-6.412a1.726,1.726,0,0,0-1.568,1.841v4.323c0,2.772,3.094,5.01,4.774,5.04,1.928.035,4.774-2.377,4.774-5.284V751.55A1.725,1.725,0,0,0,991.986,749.709Z",
    transform: "translate(-984.007 -749.709)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23547",
    "data-name": "Group 23547",
    transform: "translate(5.836 46.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22095",
    "data-name": "Path 22095",
    d: "M863.1,1116.837a14.483,14.483,0,0,0,1.287-.812c.384.841.831,1.779,1.286,2.718A29.439,29.439,0,0,1,863.1,1116.837Z",
    transform: "translate(-863.096 -1116.025)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23548",
    "data-name": "Group 23548",
    transform: "translate(38.17 46.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22096",
    "data-name": "Path 22096",
    d: "M1171.806,1117.34a13.672,13.672,0,0,1-2.292-1.315c-.572,1.253-1.284,2.725-1.955,4.087A29.248,29.248,0,0,0,1171.806,1117.34Z",
    transform: "translate(-1167.558 -1116.025)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23549",
    "data-name": "Group 23549",
    transform: "translate(18.863 21.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22097",
    "data-name": "Path 22097",
    d: "M986.648,879.691a1.651,1.651,0,0,0-.887,1.072s2.774,2.853,4.589,2.895Z",
    transform: "translate(-985.761 -879.691)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23550",
    "data-name": "Group 23550",
    transform: "translate(23.452 21.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22098",
    "data-name": "Path 22098",
    d: "M1028.967,882.437l3.581-4.111a1.678,1.678,0,0,1,.728,1.286S1030.507,882.547,1028.967,882.437Z",
    transform: "translate(-1028.967 -878.326)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23551",
    "data-name": "Group 23551",
    transform: "translate(20.824 24.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22099",
    "data-name": "Path 22099",
    d: "M1006.208,914.04s-2.733,23.586-1.781,26.463a18.6,18.6,0,0,0,.986,2.389q1.206.1,2.438.1c.187,0,.374,0,.561-.005a7.938,7.938,0,0,0,1.032-2.84c0-1.5-2.073-26.124-2.073-26.124Z",
    transform: "translate(-1004.226 -914.021)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23552",
    "data-name": "Group 23552",
    transform: "translate(21.87 23.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22100",
    "data-name": "Path 22100",
    d: "M1014.293,902.493a17.142,17.142,0,0,1,2.657-.064.279.279,0,0,1,.213.414c-.282.508-.857,1.388-1.458,1.388C1014.859,904.23,1013.544,902.551,1014.293,902.493Z",
    transform: "translate(-1014.071 -902.395)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23553",
    "data-name": "Group 23553",
    transform: "translate(15.792 3.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22101",
    "data-name": "Path 22101",
    d: "M968.4,715.371a6.833,6.833,0,0,1-3.319.519,7.021,7.021,0,0,0-8.235,5.436q1.845-1.722,2.937-.754C966.711,721.283,969.5,718.583,968.4,715.371Z",
    transform: "translate(-956.844 -715.371)",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23562",
    "data-name": "Group 23562",
    transform: "translate(644.507 612.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23560",
    "data-name": "Group 23560",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23556",
    "data-name": "Group 23556",
    transform: "translate(29.878 62.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22103",
    "data-name": "Path 22103",
    d: "M1024.995,1260.668l-.021-56.543q-.9.052-1.806.054c-.605,0-1.208-.019-1.805-.053l.021,56.543a1.819,1.819,0,0,0,1.805,1.824h0A1.82,1.82,0,0,0,1024.995,1260.668Z",
    transform: "translate(-1021.363 -1204.125)",
    fill: "#699dee",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23557",
    "data-name": "Group 23557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22104",
    "data-name": "Path 22104",
    d: "M803.38,645.638a31.671,31.671,0,0,1-29.855,31.63q-.9.054-1.806.053c-.606,0-1.209-.016-1.806-.052a31.671,31.671,0,1,1,33.467-31.631Zm-31.662,29.174a29.163,29.163,0,1,0-29.174-29.152A29.163,29.163,0,0,0,771.718,674.812Z",
    transform: "translate(-740.035 -613.977)",
    fill: "#699dee",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23558",
    "data-name": "Group 23558",
    transform: "translate(2.3 2.28)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22105",
    "data-name": "Path 22105",
    d: "M821.984,666.752A29.164,29.164,0,1,1,792.81,637.6,29.163,29.163,0,0,1,821.984,666.752Z",
    transform: "translate(-763.428 -637.37)",
    fill: "#699dee",
    fillRule: "evenodd",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22106",
    "data-name": "Path 22106",
    d: "M790.9,694.226h-.012a29.388,29.388,0,1,1,.012,0Zm-.01-58.327a28.934,28.934,0,0,0,0,57.868V694l.012-.229a28.934,28.934,0,0,0-.01-57.868Z",
    transform: "translate(-761.499 -635.441)",
    fill: "#699dee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23559",
    "data-name": "Group 23559",
    transform: "translate(5.858 12.051)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22107",
    "data-name": "Path 22107",
    d: "M835.839,753.032l11.759,6.04q-.244.541-.511,1.071l-10.612-5.45-36.634-18.818L795.2,733.49q.277-.526.575-1.039l1.735.892,38.333,19.689Zm13.1,2.472q.344-1.14.6-2.319l-19.331-9.93-30.768-15.8q-.806.885-1.537,1.835l34.892,17.922,16.149,8.295Zm-16.149-8.295q-.373-.618-.781-1.26Z",
    transform: "translate(-795.196 -727.452)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23561",
    "data-name": "Group 23561",
    transform: "translate(28.712 73.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22108",
    "data-name": "Path 22108",
    d: "M1011.615,1303.69h3.058a1.353,1.353,0,0,1,1.229,1.443v47.855a1.354,1.354,0,0,1-1.229,1.443h-3.058a1.353,1.353,0,0,1-1.229-1.443v-47.855A1.352,1.352,0,0,1,1011.615,1303.69Z",
    transform: "translate(-1010.386 -1303.69)",
    fill: "#699dee",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23563",
    "data-name": "Group 23563",
    transform: "translate(714.979 619.974)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3718",
    "data-name": "Rectangle 3718",
    width: 60.65,
    height: 17.415,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23564",
    "data-name": "Group 23564",
    transform: "translate(714.979 639.449)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3719",
    "data-name": "Rectangle 3719",
    width: 60.65,
    height: 17.415,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23565",
    "data-name": "Group 23565",
    transform: "translate(714.979 658.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3720",
    "data-name": "Rectangle 3720",
    width: 60.65,
    height: 17.416,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23566",
    "data-name": "Group 23566",
    transform: "translate(732.664 625.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22109",
    "data-name": "Path 22109",
    d: "M1609.991,739.522h-1.528a.167.167,0,1,1,0-.334h1.528a.167.167,0,0,1,0,.334Zm-6.476,1.905h-33.224a.167.167,0,0,1,0-.334h33.224a.167.167,0,0,1,0,.334Zm4.814,0H1604.2a.167.167,0,0,1,0-.334h4.129a.167.167,0,1,1,0,.334Zm-6.429-.953h-31.609a.167.167,0,0,1,0-.334H1601.9a.167.167,0,0,1,0,.334Zm8.091,0h-7.357a.167.167,0,0,1,0-.334h7.357a.167.167,0,0,1,0,.334Zm-2.235-.953h-37.464a.167.167,0,0,1,0-.334h37.464a.167.167,0,0,1,0,.334Z",
    transform: "translate(-1570.125 -739.188)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23567",
    "data-name": "Group 23567",
    transform: "translate(732.664 629.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22110",
    "data-name": "Path 22110",
    d: "M1609.991,772.747h-1.528a.167.167,0,1,1,0-.334h1.528a.167.167,0,0,1,0,.334Zm-6.476,1.905h-33.224a.167.167,0,0,1,0-.333h33.224a.167.167,0,1,1,0,.333Zm4.814,0H1604.2a.167.167,0,1,1,0-.333h4.129a.167.167,0,1,1,0,.333Zm-6.429-.953h-31.609a.167.167,0,0,1,0-.334H1601.9a.167.167,0,0,1,0,.334Zm8.091,0h-7.357a.167.167,0,0,1,0-.334h7.357a.167.167,0,0,1,0,.334Zm-2.235-.953h-37.464a.167.167,0,0,1,0-.334h37.464a.167.167,0,0,1,0,.334Z",
    transform: "translate(-1570.125 -772.413)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23568",
    "data-name": "Group 23568",
    transform: "translate(732.664 644.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22111",
    "data-name": "Path 22111",
    d: "M1609.991,920.281h-1.528a.167.167,0,1,1,0-.334h1.528a.167.167,0,0,1,0,.334Zm-6.476,1.905h-33.224a.167.167,0,0,1,0-.333h33.224a.167.167,0,1,1,0,.333Zm4.814,0H1604.2a.167.167,0,1,1,0-.333h4.129a.167.167,0,1,1,0,.333Zm-6.429-.953h-31.609a.167.167,0,0,1,0-.334H1601.9a.167.167,0,0,1,0,.334Zm8.091,0h-7.357a.167.167,0,0,1,0-.334h7.357a.167.167,0,0,1,0,.334Zm-2.235-.953h-37.464a.167.167,0,0,1,0-.334h37.464a.167.167,0,0,1,0,.334Z",
    transform: "translate(-1570.125 -919.947)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23569",
    "data-name": "Group 23569",
    transform: "translate(732.664 648.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22112",
    "data-name": "Path 22112",
    d: "M1609.991,953.505h-1.528a.167.167,0,1,1,0-.333h1.528a.167.167,0,1,1,0,.333Zm-6.476,1.906h-33.224a.167.167,0,0,1,0-.334h33.224a.167.167,0,0,1,0,.334Zm4.814,0H1604.2a.167.167,0,0,1,0-.334h4.129a.167.167,0,1,1,0,.334Zm-6.429-.953h-31.609a.167.167,0,0,1,0-.334H1601.9a.167.167,0,0,1,0,.334Zm8.091,0h-7.357a.167.167,0,0,1,0-.334h7.357a.167.167,0,0,1,0,.334Zm-2.235-.953h-37.464a.167.167,0,0,1,0-.333h37.464a.167.167,0,0,1,0,.333Z",
    transform: "translate(-1570.125 -953.172)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23570",
    "data-name": "Group 23570",
    transform: "translate(732.664 664.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22113",
    "data-name": "Path 22113",
    d: "M1609.991,1101.04h-1.528a.167.167,0,1,1,0-.333h1.528a.167.167,0,1,1,0,.333Zm-6.476,1.906h-33.224a.167.167,0,0,1,0-.334h33.224a.167.167,0,0,1,0,.334Zm4.814,0H1604.2a.167.167,0,0,1,0-.334h4.129a.167.167,0,1,1,0,.334Zm-6.429-.953h-31.609a.167.167,0,0,1,0-.334H1601.9a.167.167,0,0,1,0,.334Zm8.091,0h-7.357a.167.167,0,0,1,0-.334h7.357a.167.167,0,0,1,0,.334Zm-2.235-.953h-37.464a.167.167,0,0,1,0-.333h37.464a.167.167,0,0,1,0,.333Z",
    transform: "translate(-1570.125 -1100.707)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23571",
    "data-name": "Group 23571",
    transform: "translate(732.664 667.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22114",
    "data-name": "Path 22114",
    d: "M1609.991,1134.265h-1.528a.167.167,0,1,1,0-.333h1.528a.167.167,0,1,1,0,.333Zm-6.476,1.906h-33.224a.167.167,0,0,1,0-.334h33.224a.167.167,0,0,1,0,.334Zm4.814,0H1604.2a.167.167,0,0,1,0-.334h4.129a.167.167,0,1,1,0,.334Zm-6.429-.953h-31.609a.167.167,0,0,1,0-.334H1601.9a.167.167,0,0,1,0,.334Zm8.091,0h-7.357a.167.167,0,0,1,0-.334h7.357a.167.167,0,0,1,0,.334Zm-2.235-.953h-37.464a.167.167,0,0,1,0-.333h37.464a.167.167,0,0,1,0,.333Z",
    transform: "translate(-1570.125 -1133.932)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23575",
    "data-name": "Group 23575",
    transform: "translate(720.132 623.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23572",
    "data-name": "Group 23572",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22115",
    "data-name": "Path 22115",
    d: "M1460.053,722.747a3.966,3.966,0,1,1-3.994-3.937A3.967,3.967,0,0,1,1460.053,722.747Z",
    transform: "translate(-1452.122 -718.81)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23573",
    "data-name": "Group 23573",
    transform: "translate(2.822 0.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22116",
    "data-name": "Path 22116",
    d: "M1480.955,729.038a1.129,1.129,0,1,1-1.138-1.122A1.128,1.128,0,0,1,1480.955,729.038Z",
    transform: "translate(-1478.696 -727.916)",
    fill: "#fefefe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23574",
    "data-name": "Group 23574",
    transform: "translate(1.882 3.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22117",
    "data-name": "Path 22117",
    d: "M1471.924,752.828h0a2.1,2.1,0,0,0-2.081,2.111h0a.548.548,0,0,0,.553.545l3.091-.022a.549.549,0,0,0,.546-.553h0A2.1,2.1,0,0,0,1471.924,752.828Z",
    transform: "translate(-1469.844 -752.828)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23579",
    "data-name": "Group 23579",
    transform: "translate(720.132 642.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23576",
    "data-name": "Group 23576",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22118",
    "data-name": "Path 22118",
    d: "M1460.053,903.507a3.966,3.966,0,1,1-3.994-3.937A3.966,3.966,0,0,1,1460.053,903.507Z",
    transform: "translate(-1452.122 -899.57)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23577",
    "data-name": "Group 23577",
    transform: "translate(2.822 0.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22119",
    "data-name": "Path 22119",
    d: "M1480.955,909.8a1.129,1.129,0,1,1-1.138-1.122A1.129,1.129,0,0,1,1480.955,909.8Z",
    transform: "translate(-1478.696 -908.676)",
    fill: "#fefefe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23578",
    "data-name": "Group 23578",
    transform: "translate(1.882 3.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22120",
    "data-name": "Path 22120",
    d: "M1471.924,933.588h0a2.1,2.1,0,0,0-2.081,2.11h0a.55.55,0,0,0,.553.546l3.091-.022a.549.549,0,0,0,.546-.553h0A2.1,2.1,0,0,0,1471.924,933.588Z",
    transform: "translate(-1469.844 -933.588)",
    fill: "#fefefe",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23583",
    "data-name": "Group 23583",
    transform: "translate(720.132 661.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23580",
    "data-name": "Group 23580",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22121",
    "data-name": "Path 22121",
    d: "M1460.053,1084.266a3.966,3.966,0,1,1-3.994-3.937A3.967,3.967,0,0,1,1460.053,1084.266Z",
    transform: "translate(-1452.122 -1080.329)",
    fill: "#c3dffa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23581",
    "data-name": "Group 23581",
    transform: "translate(2.822 0.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22122",
    "data-name": "Path 22122",
    d: "M1480.955,1090.557a1.129,1.129,0,1,1-1.138-1.122A1.129,1.129,0,0,1,1480.955,1090.557Z",
    transform: "translate(-1478.696 -1089.435)",
    fill: "#fefefe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23582",
    "data-name": "Group 23582",
    transform: "translate(1.882 3.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22123",
    "data-name": "Path 22123",
    d: "M1471.924,1114.348h0a2.1,2.1,0,0,0-2.081,2.11h0a.55.55,0,0,0,.553.546l3.091-.022a.549.549,0,0,0,.546-.553h0A2.1,2.1,0,0,0,1471.924,1114.348Z",
    transform: "translate(-1469.844 -1114.347)",
    fill: "#fefefe",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23585",
    "data-name": "Group 23585",
    transform: "translate(795.52 293.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22124",
    "data-name": "Path 22124",
    d: "M91.281,1.887a5.773,5.773,0,0,0-10,0,5.714,5.714,0,0,0,0,5.773l4.57,7.915a.5.5,0,0,0,.86,0l4.57-7.915A5.714,5.714,0,0,0,91.281,1.887ZM89.249,4.941a2.967,2.967,0,1,1-2.967-2.967A2.97,2.97,0,0,1,89.249,4.941Z",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22125",
    "data-name": "Path 22125",
    d: "M198.376,119.734a1.974,1.974,0,1,0,1.974,1.974A1.976,1.976,0,0,0,198.376,119.734Z",
    transform: "translate(-112.094 -116.767)",
    fill: "#699dee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23586",
    "data-name": "Group 23586",
    transform: "translate(462.917 232.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22124-2",
    "data-name": "Path 22124",
    d: "M94.717,2.807a7.613,7.613,0,0,0-13.186,0,7.535,7.535,0,0,0,0,7.613l6.026,10.438a.654.654,0,0,0,1.133,0L94.717,10.42A7.535,7.535,0,0,0,94.717,2.807ZM92.037,6.835a3.912,3.912,0,1,1-3.912-3.912A3.917,3.917,0,0,1,92.037,6.835Z",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22125-2",
    "data-name": "Path 22125",
    d: "M199.005,119.734a2.6,2.6,0,1,0,2.6,2.6A2.606,2.606,0,0,0,199.005,119.734Z",
    transform: "translate(-110.881 -115.503)",
    fill: "#699dee"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsupportedLocationIcon);
export default __webpack_public_path__ + "static/media/unsupported-location-icon.a4dc5a2926e90893af6bb1e7a571474e.svg";
export { ForwardRef as ReactComponent };